module.exports = __webpack_public_path__ + "static/media/dealers.79e1fd16.svg";